import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { language } from "../../language/Language";

const Footer = () => {
  const isArabic = language === "ar";

  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-700 to-gray-900 py-14 font-sans tracking-wide text-sm">
      <div className="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Company Section */}
        <div>
          <h2 className="text-white text-lg font-semibold mb-4">
            {isArabic ? "الشركة" : "Company"}
          </h2>
          <ul className="space-y-4">
            <li>
              <Link
                to="/AboutUs"
                className="text-gray-300 hover:text-white transition"
              >
                {isArabic ? "من نحن" : "About Us"}
              </Link>
            </li>
          </ul>
        </div>

        {/* Important Links */}
        <div>
          <h2 className="text-white text-lg font-semibold mb-4">
            {isArabic ? "روابط مهمة" : "Important Links"}
          </h2>
          <ul className="space-y-4">
            <li>
              <Link
                to="/Products"
                className="text-gray-300 hover:text-white transition"
              >
                {isArabic ? "منتجاتنا" : "Our Products"}
              </Link>
            </li>
            <li>
              <Link
                to="/FeaturedProducts"
                className="text-gray-300 hover:text-white transition"
              >
                {isArabic ? "المنتجات المميزة" : "Featured Products"}
              </Link>
            </li>

            <li>
              <Link
                to="/Brands"
                className="text-gray-300 hover:text-white transition"
              >
                {isArabic ? "البراندات " : "Brands"}
              </Link>
            </li>
          </ul>
        </div>

        {/* Help Section */}
        <div>
          <h2 className="text-white text-lg font-semibold mb-4">
            {isArabic ? "هل تحتاج إلى مساعدة؟" : "Need Help?"}
          </h2>
          <ul className="space-y-4">
            <li>
              <a
                href="mailto:admin@meat-house.online"
                className="text-gray-300 hover:text-white transition"
              >
                admin@meat-house.online
              </a>
            </li>
            <li>
              <a
                href="https://api.whatsapp.com/send?phone=2001143837483"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition"
              >
                {isArabic ? "الهاتف: " : "Phone: "}+20 01143837483
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <hr className="my-8 border-gray-600" />

      {/* Footer Bottom */}
      <div className="container flex flex-col sm:flex-row justify-between items-center gap-6">
        {/* Social Icons */}
        <div className="flex gap-4">
          {[
            {
              icon: faFacebook,
              url: "https://www.facebook.com/Meat.House.Alfardos?mibextid=ZbWKwL",
              color: "#3b5998",
            },
          ].map((social, idx) => (
            <a
              key={idx}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform hover:scale-110"
            >
              <FontAwesomeIcon
                icon={social.icon}
                size="3x"
                color={social.color}
              />
            </a>
          ))}
        </div>

        {/* Copyright */}
        <p className="text-gray-300 text-sm text-center sm:text-right">
          {isArabic
            ? `© ${new Date().getFullYear()} جميع الحقوق محفوظة لدى Meat-house El-Fardos.`
            : `© ${new Date().getFullYear()} All rights reserved to Meat-house El-Fardos.`}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
